export enum Roles {
	KOGNI_ADMIN = 'kogni_admin',
	CUSTOMER_SUPPORT = 'customer_support'
}
